import type { variables } from '../mpanels/variables';

type Variables = typeof variables;

const createMuiAutocompleteStyles = (variables: Variables) => ({
    styleOverrides: {
        root: {
            '.MuiOutlinedInput-root .MuiAutocomplete-input': {
                padding: variables.padding.inputsDefault,
                borderRadius: variables.borderRadius.primary,
            },
            '.MuiChip-root': {
                borderRadius: variables.borderRadius.primary,
                height: '30px',
            },
            '.MuiAutocomplete-tag': {
                margin: '6px',
                maxWidth: 'calc(100% - 12px)',
            },
        },
        inputRoot: {
            padding: '0 3px',
        },
        input: {
            padding: variables.padding.inputsDefault,
        },
        paper: {
            borderRadius: variables.borderRadius.secondary,
        },
        listbox: {
            padding: '0',
        },
    },
});

export default createMuiAutocompleteStyles;
